import type { Project } from '@shared/models/project.model';
import type { Results } from '@shared/models/unit.model';
import {
  compressConversionFactors,
  sumConversionFactors,
} from '@shared/helpers/conversion-factors.helpers';
import { getC1BaseEnergyResults } from './c1.helpers';
import { getC3C4SchablonResults } from './c3-c4.helpers';

/**
 * Building-wide C-phase results that are not tied to any single product element and
 * are therefore added once at the version level (mirroring B7 operational water):
 * - C1 demolition base energy (GFA-based electricity + diesel)
 * - C3-C4 BD7/BD8 schablon for the building parts without actual modelled resources
 *
 * Per-product C-phase terms (C1 material/crane diesel, C2 transport, C3-C4 actual S12)
 * are produced by the per-product mappers and summed by the normal rollup instead.
 */
export const getCPhaseBuildingResults = (
  project: Project,
  gfa: number,
  options: { includeBd7: boolean; includeBd8: boolean },
): Results =>
  compressConversionFactors(
    sumConversionFactors(
      getC1BaseEnergyResults(gfa),
      getC3C4SchablonResults(project, gfa, options),
    ),
  );
